import Vue from 'vue'
import Vuex from 'vuex'
import config from'@/config.js';
let app_name = config.name || 'new_app';
Vue.use(Vuex)
let app_store_req={};
let stores = {};
//load default store
if(app_name!="ks_app"){
  app_store_req=require('./store/context.js');
  stores.ks_app={};
  stores.ks_app.namespaced=true;
  stores.ks_app.modules=app_store_req.default;
}
//load app store
app_store_req=require('@/store/context.js');
stores[app_name]={};
stores[app_name].namespaced=true;
stores[app_name].modules=app_store_req.default;

let module_req = {};
//load 
let modules={};
if(app_name!="ks_app"){
  module_req = require.context('./modules', true, /index\.js$/i);
  module_req.keys().map(key => {
    let name = key.match(/\w+/)[0];
    if(!modules[name]){
      modules[name]={mounted:[]}
    }
    if(module_req(key).default.mounted){
      modules[name].mounted.push(module_req(key).default.mounted)
    }

  });
}
module_req = require.context('@/modules', true, /index\.js$/i);
module_req.keys().map(key => {
  let name = key.match(/\w+/)[0];
  if(!modules[name]){
    modules[name]={mounted:[]}
  }
  if(module_req(key).default.mounted){
    modules[name].mounted.push(module_req(key).default.mounted)
  }
});
//load stores
Object.keys(modules).forEach(m=>{
  if(m!="ks_app"){
    if(app_name=="ks_app"){
      app_store_req=require(`../${m}/src/store/context.js`);
    }else{
      app_store_req=require(`../../${m}/src/store/context.js`);
    }
    
    stores[m]={};
    stores[m].namespaced=true; 
    stores[m].modules=app_store_req.default;
  }
})
//extend with ks_app and local settings todo
if(config.mounted){
  if(!modules[app_name]){
    modules[app_name]={mounted:[]}
  }
  modules[app_name].mounted.push(config.mounted)
}

let app_store = new Vuex.Store({
  modules: stores
})

//set global store
global.app.name=app_name;
global.app.store=app_store;

//call mounted events
Object.keys(modules).forEach(m=>{
  modules[m].mounted.forEach(f=>{
    f(app_store);
  })
})
export default app_store;